import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import AuthCallback from "@/pages/AuthCallback";
import { Login, Signup, ForgotPassword, ResetPassword } from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Buyers from "@/pages/Buyers";
import Leads from "@/pages/Leads";
import RFQs from "@/pages/RFQs";
import Quotations from "@/pages/Quotations";
import Followups from "@/pages/Followups";
import Orders from "@/pages/Orders";
import Analytics from "@/pages/Analytics";
import ROI from "@/pages/ROI";
import Team from "@/pages/Team";
import Users from "@/pages/Users";
import CompanySettings from "@/pages/CompanySettings";
import Subscription from "@/pages/Subscription";
import PlatformAdmin from "@/pages/PlatformAdmin";
import PublicEnquiry from "@/pages/PublicEnquiry";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Detect Google OAuth return (session_id in URL fragment) synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/enquiry/:slug" element={<PublicEnquiry />} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/buyers" element={<Buyers />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/rfqs" element={<RFQs />} />
        <Route path="/quotations" element={<Quotations />} />
        <Route path="/followups" element={<Followups />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/roi" element={<ROI />} />
        <Route path="/team" element={<Team />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<CompanySettings />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/platform" element={<PlatformAdmin />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
